var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContrast(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 138,
    viewBox: "0 0 200 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_contrast_re_hc7k 1",
    clipPath: "url(#clip0_440_217117)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.76684 130.897C6.39952 133.276 5.35254 137.586 5.35254 137.586C5.35254 137.586 9.76505 138.039 13.1324 135.66C16.4997 133.281 17.5467 128.971 17.5467 128.971C17.5467 128.971 13.1342 128.518 9.76684 130.897Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.114 132.088C9.42892 135.851 5.40138 137.71 5.40138 137.71C5.40138 137.71 4.10594 133.468 5.79105 129.705C7.47616 125.942 11.5037 124.083 11.5037 124.083C11.5037 124.083 12.7991 128.326 11.114 132.088Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M200 0.0609436H92.498V68.91H200V0.0609436Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M196.926 8.69633H95.572V34.9422H196.926V8.69633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M196.926 38.5874H95.572V64.8332H196.926V38.5874Z",
    fill: "#425CC7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M199.954 0H92.4521V4.56708H199.954V0Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M95.846 3.18141C96.3135 3.18141 96.6925 2.80243 96.6925 2.33494C96.6925 1.86744 96.3135 1.48846 95.846 1.48846C95.3785 1.48846 94.9995 1.86744 94.9995 2.33494C94.9995 2.80243 95.3785 3.18141 95.846 3.18141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M99.0591 3.18141C99.5266 3.18141 99.9056 2.80243 99.9056 2.33494C99.9056 1.86744 99.5266 1.48846 99.0591 1.48846C98.5916 1.48846 98.2126 1.86744 98.2126 2.33494C98.2126 2.80243 98.5916 3.18141 99.0591 3.18141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M102.272 3.18141C102.74 3.18141 103.118 2.80243 103.118 2.33494C103.118 1.86744 102.74 1.48846 102.272 1.48846C101.805 1.48846 101.426 1.86744 101.426 2.33494C101.426 2.80243 101.805 3.18141 102.272 3.18141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M165.093 16.9445H131.206V18.5467H165.093V16.9445Z",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M165.093 21.1102H131.206V22.7124H165.093V21.1102Z",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M165.093 25.2758H131.206V26.878H165.093V25.2758Z",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M128.451 18.8517C129.028 18.8517 129.496 18.3836 129.496 17.8061C129.496 17.2286 129.028 16.7605 128.451 16.7605C127.873 16.7605 127.405 17.2286 127.405 17.8061C127.405 18.3836 127.873 18.8517 128.451 18.8517Z",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M163.193 46.7436H129.306V48.3458H163.193V46.7436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M163.193 50.9092H129.306V52.5114H163.193V50.9092Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M163.193 55.0749H129.306V56.6771H163.193V55.0749Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M124.371 48.3421C124.949 48.3421 125.417 47.8739 125.417 47.2965C125.417 46.719 124.949 46.2509 124.371 46.2509C123.794 46.2509 123.325 46.719 123.325 47.2965C123.325 47.8739 123.794 48.3421 124.371 48.3421Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M46.8231 81.9382L43.4992 66.9809L42.7425 61.2148L37.1204 61.6832L37.697 69.7199L43.5979 83.3813C43.4076 83.8525 43.3624 84.3697 43.4683 84.8667C43.5742 85.3637 43.8263 85.8176 44.1921 86.1702C44.558 86.5229 45.0209 86.7581 45.5214 86.8456C46.0219 86.9331 46.5372 86.869 47.001 86.6615C47.4648 86.454 47.856 86.1125 48.1243 85.681C48.3925 85.2494 48.5257 84.7475 48.5065 84.2398C48.4874 83.732 48.3169 83.2416 48.0169 82.8315C47.7169 82.4213 47.3012 82.1103 46.8231 81.9382Z",
    fill: "#9F616A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M54.9909 134.763H57.8306L59.1817 123.81L54.9902 123.81L54.9909 134.763Z",
    fill: "#9F616A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M54.2666 133.836L59.8593 133.836H59.8595C60.8047 133.836 61.7113 134.212 62.3796 134.88C63.048 135.548 63.4236 136.455 63.4236 137.4V137.516L54.2668 137.516L54.2666 133.836Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M31.7751 132.668L34.5175 133.405L38.6678 123.179L34.6201 122.09L31.7751 132.668Z",
    fill: "#9F616A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M31.3164 131.584L36.7172 133.037C37.6299 133.282 38.408 133.88 38.8798 134.7C39.3516 135.519 39.4787 136.491 39.2332 137.404L39.2032 137.516L30.3606 135.138L31.3164 131.584Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M59.5357 86.7454L60.7946 88.9231C60.7946 88.9231 62.1779 89.3009 61.7258 93.8101C61.2737 98.3193 59.0323 109.475 59.0323 109.475C59.0323 109.475 61.2543 125.035 59.0659 128.323L58.67 131.146L54.5377 131.541L54.4335 129.036C54.4335 129.036 51.4439 117.527 51.9629 112.497L49.5062 94.2357C49.5062 94.2357 44.2936 107.586 42.694 110.118C42.694 110.118 40.0219 125.656 37.6212 126.492L36.7542 129.338L32.4038 128.705L33.1907 125.437C33.1907 125.437 33.2336 110.169 36.7849 105.799L39.529 86.3924L59.5357 86.7454Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M52.5845 89.9113C50.6545 89.9113 48.8617 89.6272 47.815 88.7775C46.2964 87.5446 44.3605 87.8056 42.6525 88.0358C40.9416 88.2665 39.464 88.4655 38.9126 87.0674L38.9028 87.0428L38.9048 87.0163L40.6086 64.1855L38.3469 56.291L38.3526 56.2632C38.3607 56.2239 39.1995 52.3155 42.8907 50.47L47.8659 48.1861L55.9324 48.8504L60.9927 52.8605V52.9165L61.007 88.7347L60.9199 88.7571C60.6504 88.8262 56.3559 89.9113 52.5845 89.9113Z",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M41.7688 63.9419L36.5786 62.2824L38.4635 55.7159L41.1455 56.0117L41.7688 63.9419Z",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M66.0489 85.6444L62.7251 70.6871L61.9683 64.921L56.3462 65.3895L56.9228 73.4261L62.8237 87.0875C62.6334 87.5587 62.5883 88.0759 62.6942 88.5729C62.8001 89.0699 63.0521 89.5238 63.418 89.8764C63.7838 90.2291 64.2467 90.4643 64.7472 90.5518C65.2478 90.6393 65.763 90.5752 66.2268 90.3677C66.6907 90.1602 67.0818 89.8187 67.3501 89.3872C67.6184 88.9556 67.7515 88.4537 67.7324 87.946C67.7132 87.4382 67.5427 86.9478 67.2427 86.5377C66.9428 86.1275 66.527 85.8165 66.0489 85.6444Z",
    fill: "#9F616A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M55.5726 66.3579L55.1311 60.4706L60.7243 52.7166L60.781 52.7147C60.804 52.7134 63.0538 52.6745 63.459 56.121C63.854 59.4808 62.6462 65.7284 62.6339 65.791L62.6169 65.8784L55.5726 66.3579Z",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M53.4456 46.5259C56.3239 46.0588 58.2786 43.3469 57.8115 40.4685C57.3444 37.5902 54.6324 35.6355 51.7541 36.1026C48.8758 36.5697 46.9211 39.2817 47.3882 42.16C47.8553 45.0383 50.5673 46.993 53.4456 46.5259Z",
    fill: "#9F616A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M57.4268 40.5305C57.4268 40.5305 57.4691 38.6744 57.7038 37.853C57.9384 37.0317 58.4077 36.3278 58.1731 36.3278C57.9384 36.3278 57.8211 35.7411 57.8211 35.7411C57.8211 35.7411 57.5864 35.6238 57.4691 35.7411C57.3518 35.8584 57.2345 34.9198 57.2345 34.9198C57.2345 34.9198 57.1171 34.5678 56.9998 34.8025C56.8825 35.0371 56.8825 34.9198 56.7652 34.5678C56.6478 34.2159 56.0612 33.9812 56.0612 33.9812C56.0612 33.9812 53.8319 34.0985 53.4799 33.6292C53.1279 33.1599 49.1387 33.5119 48.3174 34.0985C47.4961 34.6852 43.8589 36.7971 44.4455 38.557C45.0322 40.317 46.7209 44.3692 47.1441 44.7755C47.8133 45.4179 48.2766 45.6496 51.443 46.2796C52.0627 46.4029 55.2258 44.3801 55.2258 44.0281C55.2258 43.6761 54.8444 42.5599 55.4574 42.4066C56.384 42.175 56.4882 43.3464 56.7228 42.9944C56.9575 42.6424 57.4268 40.5305 57.4268 40.5305Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M88.486 137.61H0.231639C0.170204 137.61 0.111286 137.586 0.0678452 137.542C0.0244046 137.499 0 137.44 0 137.378C0 137.317 0.0244046 137.258 0.0678452 137.215C0.111286 137.171 0.170204 137.147 0.231639 137.147H88.486C88.5474 137.147 88.6064 137.171 88.6498 137.215C88.6932 137.258 88.7177 137.317 88.7177 137.378C88.7177 137.44 88.6932 137.499 88.6498 137.542C88.6064 137.586 88.5474 137.61 88.486 137.61Z",
    fill: "#CBCBCB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_440_217117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 137.71,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContrast);
export default __webpack_public_path__ + "static/media/contrast.879a96b891af10008d190a00140c6ae2.svg";
export { ForwardRef as ReactComponent };